import script from "./DetailHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailHeader.vue?vue&type=script&lang=ts&setup=true"

import "./DetailHeader.vue?vue&type=style&index=0&id=20d5af96&lang=scss"

const __exports__ = script;

export default __exports__